<div class="predictive-config-container" >
    <div class="loading" *ngIf="loading"></div>
    <div class="breadcrumb">
        <span class="intelligent-advisor-text" (click)="navigateToLanding()">Intelligent Advisor</span>
        <span class="configure-predictive-text"> / {{mode === 0 ? 'Configure ' + selectedConfigType.category : 'Edit configurations'}}</span>
    </div>
    <div class="main-title">
        {{mode === 0 ? 'Configure ' + selectedConfigType.category : 'Edit configurations'}}
    </div>
    <div [hidden]="!isLoading">
        <div class="loading-algolist">
            <app-three-dots-loading class="dots"></app-three-dots-loading>
            <div class="text">Loading...</div>
        </div>
    </div>
    <div [hidden]="isLoading" class="containerBody">
        <div class="predictive-selection-container">
            <div class="left-section">
                <div class="step">
                    <div [ngClass]="(showAlgorithmDropdown ? 'step-container-active' : 'step-container-inactive')">
                        <div class="step-title">
                            <span class="step-icon">
                                <img *ngIf="!showAlgorithmDropdown" src="../../../assets/step-finished.svg"/>
                                <img *ngIf="showAlgorithmDropdown" class="stepOneIcon" src=""/>
                            </span>
                            <span [ngClass]="(showAlgorithmDropdown ? 'step-text-active' : 'step-text')">
                                Algorithm
                            </span>
                        </div>
                        <mat-vertical-stepper [linear]="false"
                        [disableRipple]="true"
                        [ngClass]="{'hide': !showAlgorithmDropdown}"
                        [selectedIndex]="currentStep"
                        #stepper1>
                        <mat-step>
                            <ng-template matStepLabel>
                                <span>
                                      <img *ngIf="selectedIndex === 0" src="" class="firstTreeActive"/>
                                    <img *ngIf="selectedIndex !== 0"  src="../../../assets/first-tree-inactive.svg"/>
                                </span>
                                <span class="step-title">
                                    Algorithm
                                </span>
                            </ng-template>
                        </mat-step>
                        <mat-step>
                            <ng-template matStepLabel>
                                <span>
                                   <img *ngIf="selectedIndex === 1" src="" class="secondTreeActive"/>
                                    <img *ngIf="selectedIndex !== 1"  src="../../../assets/second-tree-inactive.svg"/>
                                </span>
                                <span class="step-title">
                                    Asset Selection
                                </span>
                            </ng-template>
                        </mat-step>
                        </mat-vertical-stepper>
                    </div>
                    <div class="step-container">
                        <div class="step-title">
                            <span class="step-icon">
                                <img *ngIf="!showConfigurationDropdown" src="../../../assets/step-two-inactive.svg"/>
                                <img *ngIf="showConfigurationDropdown" class="stepTwoIcon" src=""/>
                            </span>
                            <span [ngClass]="(showConfigurationDropdown ? 'step-text-active' : 'step-text')">
                                Configuration
                            </span>
                        </div>
                        <mat-vertical-stepper [linear]="false"
                        [disableRipple]="true"
                        [ngClass]="{'hide': !showConfigurationDropdown}"
                        [selectedIndex]="currentStep"
                        #stepper2>
                        <mat-step>
                            <ng-template matStepLabel>
                                <span>
                                    <img *ngIf="selectedIndex === 2" src="" class="firstTreeActive"/>
                                    <img *ngIf="selectedIndex !== 2"  src="../../../assets/first-tree-inactive.svg"/>
                                </span>
                                <span>
                                    Configuration
                                </span>
                            </ng-template>
                        </mat-step>
                        <mat-step>
                            <ng-template matStepLabel>
                                <span>
                                   <img *ngIf="selectedIndex === 3" src="" class="secondTreeActive"/>
                                    <img *ngIf="selectedIndex !== 3"  src="../../../assets/second-tree-inactive.svg"/>
                                </span>
                                <span>
                                    Impacted KPIS
                                </span>
                            </ng-template>
                        </mat-step>
                        </mat-vertical-stepper>
                    </div>
                </div>
            </div>
            <div class="right-section">
                <div class="right-section-top-container">
                    <mat-tab-group class="predicitve-failure-tab"
                        [selectedIndex]="selectedIndex"
                        animationDuration="0ms">
                        <mat-tab [disabled]="true">
                            <ng-template matTabContent>
                                <app-predictive-algorithm></app-predictive-algorithm>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="true">
                            <ng-template matTabContent>
                                <app-predictive-asset-selection></app-predictive-asset-selection>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="true">
                            <ng-template matTabContent>
                                <app-predictive-configuration></app-predictive-configuration>
                            </ng-template>
                        </mat-tab>
                        <mat-tab [disabled]="true">
                            <ng-template matTabContent>
                                <app-predictive-impacted-kpi></app-predictive-impacted-kpi>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
        <div class="buttons-container">
            <div class="buttons-sub-container">
                <span class ="cancel-button">
                    <ng-container>
                        <button (click)="onLeftButtonClick()" class="submit-button-enabled button-md">
                            <div class="cancel-button-text">
                                {{selectedIndex === PREDICTIVE_CREATE_COMPONENTS.ALGORITHM ? 'CANCEL' : 'BACK'}}
                            </div>
                        </button>
                    </ng-container>
                </span>
                <span class ="submit-button">
                    <ng-container *ngIf="assetsDuplicated && selectedIndex === PREDICTIVE_CREATE_COMPONENTS.ASSETS">
                        <button class="delete-button"(click)="onRightErrorButtonClick()"> 
                            <div class="delete-button-text">
                                DELETE DUPLICATES
                            </div>
                        </button>
                    </ng-container>
                    <ng-container>
                        <button (click)="onRightButtonClick()" 
                            class="button-md" 
                            [ngClass]="{'button-md-submit': selectedIndex === PREDICTIVE_CREATE_COMPONENTS.IMPACTED_KPIS ,'submit-button-disabled': isDisabled, 'submit-button-enabled' : !isDisabled}"
                            [disabled]="isDisabled  || disableOnSubmit">
                            <div class="submit-button-text">
                                {{selectedIndex === PREDICTIVE_CREATE_COMPONENTS.IMPACTED_KPIS ? ((mode === CONFIG_MODE.CREATE ? 'CREATE' : 'SAVE') + ' CONFIGURATION') : 'NEXT STEP'}}
                            </div>
                        </button>
                    </ng-container>
                </span>
            </div>
        </div>
    </div>
</div>

